import React, { useState } from 'react'
import {
  Layer,
  Box,
  Button,
  Form,
  FormField,
  TextInput,
  Heading,
  Text,
  Select,
  Anchor,
  Tip
} from 'grommet'
import { Close, FormAdd, Trash, Add, CircleInformation } from 'grommet-icons'
import filter from 'lodash/filter'
import { API } from '../../libs/amplifyAPI'

const AddRepository = ({ onClose, onSuccess }) => {
  const [formValue, setFormValue] = useState({
    name: '',
    defaultBranch: '',
    category: 'Sense',
    owner: 'qlik-trial',
    description: '',

    localeType: 'short',
    files: [{ path: '', latestCommit: '' }]
  })
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState(null)

  const handleAddFile = () => {

    setFormValue(prev => {
      const newFiles = [...prev.files, { path: '' }]
      return {
        ...prev,
        files: newFiles
      }
    })
  }

  const handleRemoveFile = (index) => {
    setFormValue(prev => {
      const newFiles = filter(prev.files, (item, _index) => {
        return index !== _index
      });
      return {
        ...prev,
        files: newFiles
      }
    })
  }

  const handleSubmit = () => {
    setSubmitting(true)
    setError(null)

    // Filter out empty file paths
    const filesArray = formValue.files
      .map(file => {
        return {
          path: file.path.trim(),
          latestCommit: file.latestCommit?.trim() || ''
        }
      })

    

    const errorMessages = [];
    filesArray.some(file => {
      if(!file.path){
        errorMessages.push('Please fill in all file paths or remove empty file entries.')
        return true;
      } 
      return false;
    })

    const repositoryData = {
      name: formValue.name.trim(),
      defaultBranch: formValue.defaultBranch.trim(),
      category: formValue.category,
      owner: formValue.owner.trim(),
      description: formValue.description.trim(),
      localeType: formValue.localeType,
      // files: filesArray
    }
    

    if (formValue.category === 'Plural') {
      repositoryData.isPlural = true;
      filesArray.some(file => {
        file.isPlural = true;
        if(!file.path.match(/plural/mig)) {
          errorMessages.push('All file paths must include "plural" for Plural category.')
          return true;
        }
        return false;
      });
      filesArray.some(file => {
        file.isPlural = true;
        if(!file.path.endsWith('.json')) {
          errorMessages.push('All file must be JSON files for Plural category.')
          return true;
        }
        return false;
      });
    } else if(formValue.category !== 'Plural') {
      filesArray.some(file => {
        if(file.path.match(/plural/mig)) {
          errorMessages.push('File paths must NOT include "plural" for non-Plural category.')
          return true;
        }
        return false;
      });
      filesArray.some(file => {
        file.isPlural = true;
        if(!file.path.endsWith('.json') && !file.path.endsWith('.resx')) {
          errorMessages.push('All file paths must be JSON or RESX files.')
          return true;
        }
        return false;
      });
    }

    let locale = 'en';
    if(formValue.localeType === 'long') {
      locale = 'en-US';
    }
    filesArray.some(file => {
      if(!file.path.includes(locale)) {
        errorMessages.push(`File paths must include English locale code '${locale}'.`)
        return true;
      }
      return false;
    });
    if(errorMessages.length > 0) {
      setError(errorMessages)
      setSubmitting(false)
      return
    }

    

    repositoryData.files = filesArray;

    // Add the repository via API
    API.post('LocmanUI', 'repositories', { body: repositoryData })
      .then(() => {
        setSubmitting(false)
        onSuccess() // Call onSuccess to refresh the list
        onClose()
      })
      .catch(err => {
        console.error('Error adding repository:', err)
        setError(err.message || 'Failed to add repository. Please try again.')
        setSubmitting(false)
      })
  }

  const onChangeField = (nextValue) => {
    setFormValue(nextValue)
  }

  return (
    <Layer
      // full
      position="center"
      onClickOutside={onClose}
      onEsc={onClose}
    >
      <Box pad="medium" gap="small" width="large" alignSelf='stretch' overflow='scroll'>
        <Box direction="row" justify="between" align="center">
          <Heading level={3} margin="none">Add Repository</Heading>
          <Button icon={<Close />} onClick={onClose} />
        </Box>
        
        {error && (
          <Box 
            background="status-error" 
            pad="small" 
            round="small"
            gap="xsmall"
          >
            {error.map((msg, index) => (
              <Text key={index} color="white" size="small">{msg}</Text>
            ))}
          </Box>
        )}
        
        <Form
          value={formValue}
          onChange={onChangeField}
          onSubmit={handleSubmit}
        >
        <Box direction="row" gap="xsmall">
          <FormField
            name="name"
            label="Github Repository Name"
            validate={[
              { regexp: /^[a-zA-Z0-9-]+/i },
            ]}
            required
          >
            <TextInput
              name="name"
              placeholder="e.g., qcs-ui-common"
            />
          </FormField>
          <Box direction="row" gap="xsmall" align="start">
            <FormField
              name="description"
              label="Description (max 20 characters, only accept a-z, A-Z, 0-9, and -)"
            >
              <TextInput
                name="description"
                placeholder="Brief description of the repository/files"
                maxLength={20}
                pattern="[a-zA-Z0-9\-]+"
              />
            </FormField>
            <Tip
              responsive={false}
              content={
                <Box pad="small" gap="xsmall" width="medium" background="white" >
                  <Text size="small">
                    In case we want to split files of same repository based on file type, give it a unique description to differentiate them.
                  </Text>
                  <Text size="small">
                    e.g., in notification-prep, we have &apos;appCreated&apos; and &apos;automlDeploymentCreated&apos;. 
                    Repository name and description together MUST be unique across repositories.
                  </Text>
                  <Text size="small">
                    If a repo have plural files and regular files, you MUST separate them into two repositories and give them unique descriptions, usually I will give plural repo description &apos;plural&apos;.
                  </Text>
                </Box>
              }
            >
              <Button icon={<CircleInformation size="large" />} plain margin={{ top: "medium" }} />
            </Tip>
          </Box>
          </Box>

          <Box direction="row" gap="xsmall">
            <FormField
              name="owner"
              label="Owner"
              required
            >
              <TextInput
                name="owner"
                placeholder="e.g., qlik-trial"
              />
            </FormField>
            <FormField
              name="defaultBranch"
              label="Branch"
              required
            >
              <TextInput
                name="defaultBranch"
                placeholder="e.g., main"
              />
            </FormField>

            <FormField
              name="category"
              label="Category"
              required
            >
              <Select
                name="category"
                options={['Sense', 'Plural', 'Qlikview', 'NPrinting', 'Automl', 'NLG']}
              />
            </FormField>
            <FormField
              name="localeType"
              label="Locale Type"
              required
              info="Select 'long' for full locale (e.g., en-US) or 'short' for abbreviated codes (e.g., en)"
            >
              <Select
                name="localeType"
                options={['short', 'long']}
              />
            </FormField>
          </Box>

          <Box gap="small">
            <Text weight="bold">File Paths (at least one required) Only accept json or resx file</Text>
            {formValue.files.map((file, index) => (
              <Box key={index}>
                <Box direction="row" gap="xsmall" align="center">
                  <FormField
                    name={`files[${index}].path`}
                    label={`File ${index + 1}`}
                    // style={{ flex: 1, margin: 0 }}
                    info='make sure this file exists'
                    required
                  >
                    <TextInput
                      id={`files[${index}].path`}
                      name={`files[${index}].path`}
                      placeholder="e.g., translation/en.json, translation/en/myFile.json"
                    />
                  </FormField>
                  <FormField
                    name={`files[${index}].latestCommit`}
                    label={`File ${index + 1} baseline Commit Full Hash`}
                    // style={{ flex: 1, margin: 0 }}
                    info="Locman will monitor from (NOT include) this commit"
                  >
                    <TextInput
                      name={`files[${index}].latestCommit`}
                      placeholder="e.g., 78b205e7f0cac1c79b474bf026204073b5123be8"
                    />
                  </FormField>
                  {formValue.files.length > 1 && (
                    <Button
                      // id={`remove-file-${index}`}
                      icon={<Trash />}
                      onClick={() => handleRemoveFile(index)}
                      tip="Remove file"
                    />
                  )}
                </Box>
                {file.path && (<Box>
                  <Anchor
                    key={`url-${index}`}
                    href={`https://github.com/${formValue.owner || '<owner>'}/${formValue.name || '<repository>'}/blob/${formValue.defaultBranch || '<branch>'}/${file.path || '<file-path>'}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    size='small'
                  >
                    {`Click here and make sure this file exists: https://github.com/${formValue.owner || '<owner>'}/${formValue.name || '<repository>'}/blob/${formValue.defaultBranch || '<branch>'}/${file.path || '<file-path>'}`}
                  </Anchor>

                </Box>)}
              </Box>
            ))}
            <Button
              icon={<Add />}
              label="Add File"
              onClick={handleAddFile}
              alignSelf="start"
              plain
              hoverIndicator
            />
          </Box>

          <Box direction="row" gap="medium" justify="end" margin={{ top: 'medium' }}>
            <Button
              label="Cancel"
              onClick={onClose}
              disabled={submitting}
            />
            <Button
              type="submit"
              label={submitting ? "Adding..." : "Add Repository"}
              primary
              icon={<FormAdd />}
              disabled={submitting}
            />
          </Box>
        </Form>
      </Box>
    </Layer>
  )
}

export default AddRepository
